import { useMemo } from 'react';
import { Separator } from 'react-resizable-panels';

interface GripSeparatorProps {
  orientation: 'horizontal' | 'vertical';
}

const GripSeparator = ({ orientation }: GripSeparatorProps) => {
  const isIPad = useMemo(() => {
    const ua = navigator.userAgent;
    return /iPad/.test(ua) || (/Macintosh/.test(ua) && 'ontouchend' in document);
  }, []);

  return (
    <Separator
      style={{
        margin: '0 auto',
        zIndex: 1000,
        borderRadius: '4px',
        cursor: orientation === 'vertical' ? 'row-resize' : 'col-resize',
        border: '1px solid transparent',
        outline: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...(isIPad
          ? {
              minHeight: orientation === 'vertical' ? '100%' : 12,
              minWidth: orientation === 'horizontal' ? '100%' : 12,
            }
          : {
              minHeight: orientation === 'vertical' ? '100%' : 8,
              minWidth: orientation === 'horizontal' ? '100%' : 8,
            }),
      }}
    >
      <span
        style={{
          display: 'grid',
          gridTemplateColumns: orientation === 'horizontal' ? 'repeat(3, 4px)' : 'repeat(1, 4px)',
          gridTemplateRows: orientation === 'horizontal' ? 'repeat(1, 4px)' : 'repeat(3, 4px)',
          gap: '2px',
        }}
      >
        {[...Array(3)].map((_, i) => (
          <span
            key={i}
            style={{
              width: 2,
              height: 2,
              borderRadius: '50%',
              backgroundColor: '#505050',
            }}
          />
        ))}
      </span>
    </Separator>
  );
};

export default GripSeparator;
